import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import axios from '../../axios/axios';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { storage } from '../../firebase/index';
import DefaultImage from '../../images/default.jpg';
import Snackbar, { openSnackbar } from '../utils/Snackbar';
import { connect } from "react-redux";

import 'react-quill/dist/quill.snow.css'
import Wysiwyg from './Wysiwyg'

const styles = theme => ({
    root: {

    },
    container: {
        width: '75%',
        margin: '10px auto'
    },
    blogImage: {
        width: '100%'
    },
    textField: {
        margin: '10px 0'
    },
    headerText: {
        margin: '10px 0',
        fontSize: '50px',
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '30px'
        }
    },
    button: {
        margin: "10px 0"
    }
});

class BlogPost extends Component {

    state = {
        selectedFile: '',
        imageUrl: DefaultImage,
        title: '',
        content: ''
    }

    fileSelectorHandler = (event) => {
        this.setState({
            selectedFile: event.target.files[0],
            imageUrl: URL.createObjectURL(event.target.files[0])
        });
    }

    onInpuFieldChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleChange = html => {
        this.setState({ content: html })
    }

    componentDidMount() {
        if (this.props.token === "") {
            this.props.history.push("/admin");
            return;
        }
    }

    saveBlog = (e) => {
        e.preventDefault();

        if (this.state.title === "") {
            openSnackbar({ message: "Please enter title", variant: "info" });
        } else if (this.state.content === "") {
            openSnackbar({ message: "Please enter blog content", variant: "info" });
        } else {

            const currentDate = new Date();

            const image = this.state.selectedFile;
            const uploadFile = storage.ref(`blog_images/${image.name + "-" + currentDate}`).put(image);
            uploadFile.on('state_changed', (snapshot) => {
                openSnackbar({ message: "Uploading Image", variant: "info" });
            }, (err) => {
                openSnackbar({ message: "Something went wrong", variant: "error" });
                console.log(err);
            }, () => {
                storage.ref('blog_images').child(image.name + "-" + currentDate).getDownloadURL()
                    .then(url => {
                        let data = {
                            title: this.state.title,
                            imageUrl: url,
                            content: this.state.content
                        }

                        axios.post('blog/insert', data, {
                            headers: {
                                authorization: `Bearer ${this.props.token}`
                            }
                        }).then(result => {
                            if (result.status === 200) {
                                if (result.data.success) {
                                    openSnackbar({ message: result.data.msg, variant: "success" });
                                } else {
                                    openSnackbar({ message: result.data.msg, variant: "error" });
                                }
                            } else {
                                openSnackbar({ message: "Something went wrong", variant: "error" });
                            }
                        }).catch(exception => {
                            if (exception.msg === undefined) {
                                openSnackbar({ message: "Something went wrong", variant: "error" });
                            } else {
                                openSnackbar({ message: exception.msg, variant: "error" });
                            }
                            console.log(exception);
                        });
                    });
            });
        }
    }

    render() {
        const { classes } = this.props;
        // let formClasses = [classes.containerInput, "container"].join(" ");
        return (
            <section className={classes.container}>
                <Snackbar />
                <Typography variant="h1" className={classes.headerText}>New Blog</Typography>
                <div>
                    <img src={this.state.imageUrl} alt="blog" className={classes.blogImage} />
                    <br />
                    <input onChange={this.fileSelectorHandler} type="file" />
                </div>
                <Fragment>
                    <TextField
                        label="Title"
                        name="title"
                        type="text"
                        fullWidth
                        variant="outlined"
                        className={classes.textField}
                        value={this.state.title}
                        onChange={this.onInpuFieldChange}
                    />
                    <Wysiwyg
                        onChange={this.handleChange}
                        value={this.state.content}
                        placeholder="Start writing something beautiful here"
                    />
                    <Button onClick={this.saveBlog} variant="outlined" color="secondary" className={classes.button}>
                        Save</Button>
                </Fragment>
            </section>
        );
    }
}

BlogPost.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    return {
        token: state.login.token
    }
}

export default connect(mapStateToProps)(withStyles(styles)(BlogPost));